import { Loader2 } from 'lucide-react';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';

const AREA = {
  page: 'min-h-[calc(100dvh-9rem)] md:min-h-[calc(100dvh-12rem)]',
  section: 'min-h-[45dvh]',
} as const;

export function Spinner({ area = 'section', delay = 300 }: { area?: keyof typeof AREA; delay?: number }) {
  const box = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | null>(null);
  const [shown, setShown] = useState(delay <= 0);

  useLayoutEffect(() => {
    const top = box.current?.getBoundingClientRect().top ?? 0;
    setHeight(Math.max(160, window.innerHeight - 2 * top));
  }, []);

  useEffect(() => {
    if (delay <= 0) return;
    const t = window.setTimeout(() => setShown(true), delay);
    return () => window.clearTimeout(t);
  }, [delay]);

  return (
    <div
      ref={box}
      role="status"
      aria-label="Đang tải…"
      style={height ? { minHeight: height } : undefined}
      className={`flex w-full items-center justify-center ${height ? '' : AREA[area]}`}
    >
      {shown && <Loader2 size={28} className="animate-spin text-brand-700 dark:text-brand-300" aria-hidden="true" />}
    </div>
  );
}
